import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from 'app/services/base/base.service';
import {Query} from 'app/models/query/query';
import {AppModulePath} from 'app/models/app-module-path';
import {WebMethodResult} from '../../models/web-method-result';

import {UserCalendar} from 'app/models/lookups/user-calendar';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class UserCalendarService extends BaseService {
  private listUserCalendarItemsURL = '/api/user-calendar/list';
  private saveUserCalendarItemURL = '/api/user-calendar/save';
  private deleteUserCalendarItemURL = '/api/user-calendar/delete/';
  private updateUserCalendarItemURL = '/api/user-calendar/update';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  listUserCalendarItems(qry: Query): Observable<UserCalendar[]> {
    const url = this.listUserCalendarItemsURL + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<UserCalendar[]>(url, AppModulePath.USER_CALENDAR).pipe(
      map(res => res.map(obj => new UserCalendar(obj))),
      catchError(this.handleError));
  }

  saveUserCalendarItem(userCalendar: UserCalendar) {
    return this.post<UserCalendar>(this.saveUserCalendarItemURL, AppModulePath.USER_CALENDAR, userCalendar)
      .subscribe(res => res);
  }

  deleteUserCalendarItem(id: number): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUserCalendarItemURL + id, AppModulePath.USER_CALENDAR).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  updateUserCalendarItem(userCalendarItem: UserCalendar): Observable<UserCalendar> {
    return this.post<UserCalendar>(this.updateUserCalendarItemURL, AppModulePath.USER_CALENDAR, userCalendarItem).pipe(
      map(res => new UserCalendar(res)));
  }
}
